import React, { Fragment } from "react";

const LEFT_PAGE = 'LEFT';
const RIGHT_PAGE = 'RIGHT';

/**
 * Helper method for creating a range of numbers
 * range(1, 5) => [1, 2, 3, 4, 5]
 */
const range = (from, to, step = 1) => {
  let i = from;
  const range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
}

const fetchPageNumbers = (totalPages, currentPage, pageNeighbours) => {
  /**
   * totalNumbers: the total page numbers to show on the control
   * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
   */
  const totalNumbers = (pageNeighbours * 2) + 3;
  const totalBlocks = totalNumbers + 2;
  if (totalPages > totalBlocks) {

    const startPage = Math.max(2, currentPage - pageNeighbours);
    const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);

    let pages = range(startPage, endPage);

    /**
     * hasLeftSpill: has hidden pages to the left
     * hasRightSpill: has hidden pages to the right
     * spillOffset: number of hidden pages either to the left or to the right
     */
    const hasLeftSpill = startPage > 2;
    const hasRightSpill = (totalPages - endPage) > 1;
    const spillOffset = totalNumbers - (pages.length + 1);

    switch (true) {
      // handle: (1) < {5 6} [7] {8 9} (10)
      case (hasLeftSpill && !hasRightSpill): {
        const extraPages = range(startPage - spillOffset, startPage - 1);
        pages = [LEFT_PAGE, ...extraPages, ...pages];
        break;
      }

      // handle: (1) {2 3} [4] {5 6} > (10)
      case (!hasLeftSpill && hasRightSpill): {
        const extraPages = range(endPage + 1, endPage + spillOffset);
        pages = [...pages, ...extraPages, RIGHT_PAGE];
        break;
      }

      // handle: (1) < {4 5} [6] {7 8} > (10)
      case (hasLeftSpill && hasRightSpill):
      default: {
        pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
        break;
      }
    }
    return [1, ...pages, totalPages];
  }

  return range(1, totalPages);
}

const gotoPage = (newPage, parentComp) => {
  parentComp.onPageChanged(newPage);
}

const handleClick = (newPage, parentComp) => evt => {
  evt.preventDefault();
  gotoPage(newPage, parentComp);
}

const handleMoveLeft = (currentPage, pageNeighbours, parentComp) => evt => {
  evt.preventDefault();
  gotoPage((currentPage - (pageNeighbours * 2) - 1), parentComp);
}

const handleMoveRight = (currentPage, pageNeighbours, parentComp) => evt => {
  evt.preventDefault();
  gotoPage((currentPage + (pageNeighbours * 2) + 1), parentComp);
}

export const PaginationBar = props => {
  // What we need here?
  // On click on each <a> will trigger the getaction with the
  // specific page as value.
  // how to calculate the ammount of <a>
  // we need the total count limit and page where we are
  // with total count / limit = total pages.
  // if pages > than 4. we set 'page' as first, then
  // 7 boxes ..    [1(0)][2(1+1) or ..][n-2][n-1][n][total-2 or ..][total-1]
  const { total, limit, currentPage, onPageChanged } = props;
  const pageNeighbours = 1;
  const totalPages = Math.ceil(total / limit);
  if (!props.total || props.totalPages === 1) return null;

  const pages = fetchPageNumbers(totalPages, currentPage, pageNeighbours);

  return (
    <Fragment>
      <div className="pagination">
        <div className="btn-group">
          {pages.map((page, index) => {

            if (page === LEFT_PAGE) return (<>
              <a className="page-link" href="#" aria-label="Previous" onClick={handleMoveLeft(currentPage, pageNeighbours, onPageChanged)} className="btn btn-sm btn-sec">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </>
            );
            if (page === RIGHT_PAGE) return (<>
              <a className="page-link" href="#" aria-label="Next" onClick={handleMoveRight(currentPage, pageNeighbours, onPageChanged)} className="btn btn-sm btn-sec">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </>
            );
            return (<>
              <a className="page-link" href="#" onClick={handleClick(page, onPageChanged)} class={`btn btn-sm btn-sec ${currentPage === page ? ' active' : ''}`}>{page}</a>
            </>
            );
          })}
        </div>
      </div>
    </Fragment>
  );
}
